import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTie, faCogs, faHeadset } from '@fortawesome/free-solid-svg-icons';
import styles from '../css/comuns/PorQueEscolher.module.css';
import { config } from '../../data';

const PorQueEscolher = () => {
  // Mapeamento de ícones
  const iconMap = {
    faUserTie,
    faCogs,
    faHeadset,
  };

  const recursos = config.content.porQueEscolher.map(recurso => ({
    ...recurso,
    icon: iconMap[recurso.icon],
  }));

  return (
    <section id="sobre" className={styles['secao']}>
      <div className="container">
        <h2 className={`text-center ${styles['texto-oni-azul']} mb-5`}>Por Que Escolher a Oni Telecom?</h2>
        <div className="row">
          {recursos.map((recurso, index) => (
            <div className="col-md-4 mb-4" key={index}>
              <div className={styles['item-recurso']}>
                <div className={styles['icone-recurso']}>
                  <FontAwesomeIcon icon={recurso.icon} />
                </div>
                <h4 className={styles['titulo-recurso']}>{recurso.titulo}</h4>
                <p>{recurso.descricao}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PorQueEscolher;